import PopularTrip from "./populartrips";
import PopularDestinations from "./populardestinations";
import CurrencyConverter from "./currencyconv";
import NewHero from "./NewHero";
import ImageSlider from "./ImageSlider";
import FAQ from "./FAQ";

export default function Home() {
    return(
        <div>
            <NewHero/>
            <ImageSlider />
            <PopularDestinations />
            <PopularTrip />
            <FAQ />
            <CurrencyConverter />
        </div>
    );
}
